import Vue from 'vue'
import Element from 'element-ui'
import { Container, Header, Main, Footer, Pagination, Tooltip, Breadcrumb, BreadcrumbItem, Tabs, TabPane, Calendar, Loading, Dropdown, DropdownItem, DropdownMenu, Popover } from 'element-ui'
// import Header from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(Element)
Vue.use(Container)
Vue.use(Header)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Pagination)
Vue.use(Tooltip)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Calendar)
Vue.use(Loading)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Popover)